import { render, staticRenderFns } from "./specificMerchant.vue?vue&type=template&id=244337c7&scoped=true&"
import script from "./specificMerchant.vue?vue&type=script&lang=js&"
export * from "./specificMerchant.vue?vue&type=script&lang=js&"
import style0 from "./specificMerchant.vue?vue&type=style&index=0&lang=css&"
import style1 from "./specificMerchant.vue?vue&type=style&index=1&id=244337c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244337c7",
  null
  
)

export default component.exports